// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_78-4";
export var collapsed = "_78-1";
export var headerBar = "_78-0";
export var leftHeaderContent = "_78-3";
export var subjectContainer = "_78-2";